// MeetingRoom Add
import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const MainTitleSection = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export const MeetingRoomContentWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
});
